import React, { Component, Fragment } from "react";
import "./../app.scss";
import { connect } from "react-redux";
import LoadingPage from "./../components/UiComponents/LoadingPage";
import Tutorial from "./../components/tutorial";
import Confirmation from "./../components/commonComponents/confirmationBox";
import EndScreen from "./../components/endScreen";
import CallContainer from "./CallContainer";
import * as initActions from "../actions/init";
import {
    startTutorial,
    stopTutorial,
    endTutorial,
    addStepsToTutorial,
    updateStepNumber
} from "../actions/tutorial";
import { stopCallNotification } from "./../actions/call";
import { stopMeetingNotification } from "./../actions/meeting";
import getLabel from './../utils/labels'

class GameWrapperContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isConfirmationOpen: false
        };
    }

    componentDidMount() {
        if (this.props.tutorial.tutorialStatus === -1) {
            initActions.getTutorialStatus();
        }

        if (!this.props.tutorial.isRunning && this.props.match.url.includes("/tutorial/")) {
            //if page is refreshed, go to the first page
            //if url contains reply, need to go back one step
            if (window.location.href.includes("/reply")) {
                window.location.href =
                    window.location.href
                        .split("/")
                        .slice(0, -2)
                        .join("/") + "/tutorial";
            }
            window.location.href =
                window.location.href
                    .split("/")
                    .slice(0, -2)
                    .join("/") + "/tutorial";
        }

        if (!this.props.uiState.timerDetails.isTimerOn) {
            if (this.props.match.path.includes("/tutorial")) {
                this.props.startTimerForSim(true);
            } else {
                this.props.startTimerForSim(false);
            }
        }
    }

    componentWillReceiveProps = nextProps => {
        if (
            nextProps.tutorial.tutorialStatus !== 2 &&
            !this.props.match.url.includes("/tutorial")
        ) {
            initActions.changeTutorialStatus({
                status: 2
            });
        }
    };

    goToTutorialEndPage = () => {
        if (window.location.href.includes("/tutorial/1")) {
            // Temporary for now -> this code is used to skip from the second page of the tutorial
            if (window.location.href.includes("/reply")) {
                window.location.href = window.location.href.split("/").slice(0, -2).join("/") + "-end";
            } else {
                window.location.href = window.location.href.split("/").slice(0, -1).join("/") + "-end";
            }
        } else {
            window.location.href = window.location.href + "-end";
        }
    };

    openConfirmationBox = () => {
        this.setState({
            isConfirmationOpen: true
        });
    };

    closeConfirmationBox = () => {
        this.setState({
            isConfirmationOpen: false
        });
    };

    closeHelpMenu = () => {
        this.props.closeHelpMenu();
    };

    render() {
        const { uiState, calls, meetings } = this.props;
        let { isConfirmationOpen } = this.state;

        return (
            <Fragment>
                {!uiState.gameState.isGameOver ? (
                    <div
                        className="game-container"
                        style={{ height: this.props.uiState.dimension.height }}
                        onClick={this.closeHelpMenu}
                    >
                        <Tutorial
                            tutorial={this.props.tutorial}
                            stopTutorial={stopTutorial}
                            updateStepNumber={updateStepNumber}
                        />
                        {uiState.user.userId ? (
                            this.props.children
                        ) : (
                                <LoadingPage />
                            )}
                        {uiState.gameState.isIncomingCall ||
                            uiState.gameState.currentCallId ||
                            uiState.gameState.isIncomingMeeting ||
                            uiState.gameState.currentMeetingId ? (
                                <CallContainer
                                    calls={calls}
                                    meetings={meetings}
                                    stopCallNotification={stopCallNotification}
                                    currentCallId={uiState.gameState.currentCallId}
                                    stopMeetingNotification={
                                        stopMeetingNotification
                                    }
                                    currentMeetingId={
                                        uiState.gameState.currentMeetingId
                                    }
                                />
                            ) : null}
                        {window.location.href.includes("/tutorial") &&
                            !window.location.href.includes("-end") ? (
                                <div className="tutorial-mode-banner">
                                    {getLabel('label_tutorial_mode_text')}
                                </div>
                            ) : null}
                        {this.props.tutorial.tutorialStatus >= 1 &&
                            window.location.href.includes("/tutorial") &&
                            !window.location.href.includes("-end") ? (
                                <div
                                    className="skip-tutorial-button"
                                    onClick={this.openConfirmationBox}
                                >
                                    {getLabel('label_skip_button')}
                                </div>
                            ) : null}
                        {isConfirmationOpen ? (
                            <Confirmation
                                acceptButtonText={getLabel('label_skip_button')}
                                confimationMessage={getLabel('label_skip_tutorial_message')}
                                onAcceptClick={this.goToTutorialEndPage}
                                onCancelClick={this.closeConfirmationBox}
                                isTutorialLogout={true}
                            />
                        ) : null}
                    </div>
                ) : (
                        <EndScreen downloadReport={initActions.downloadReport}
                            logoutType={this.props.uiState.user.logoutType} />
                    )}
            </Fragment>
        );
    }
}

const mapStatetoProps = state => {
    return state;
};

export default connect(
    mapStatetoProps,
    { ...initActions, stopCallNotification }
)(GameWrapperContainer);



// WEBPACK FOOTER //
// /src/containers/GameWrapperContainer.js